// extracted by css-extract-rspack-plugin
export default {"stars":"Rating-module__stars___REq6y","star":"Rating-module__star___RQnFi","starFill":"Rating-module__starFill___Ipfmt","starIcon":"Rating-module__starIcon___Clgot"};